module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"template":"Template","createFromTemplate":"Create trip from template"},"no":{"template":"Mal","createFromTemplate":"Opprett tur fra mal"}}')
  delete Component.options._Ctor
}
